'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { media } from '../../mixins/media.js';
import { ContentWrapper } from '../ContentWrapper/ContentWrapper.js';
import { FullscreenLayoutFooter } from './FullscreenLayoutFooter.js';

const StyledContentInner = styled(ContentWrapper).withConfig({
  componentId: "sc-1lcjl70-0"
})(["", ""], media.greaterThan('s')`
    padding-top: ${({
  theme
}) => theme.components.fullscreenLayout.contentPaddingTop};
    margin-top: 0;
  `);
const FullscreenLayoutContent = /*#__PURE__*/withTitan(({
  footer,
  children,
  testId = 'fullscreenLayoutContent'
}) => {
  return jsxs(Fragment, {
    children: [jsx(StyledContentInner, {
      id: "modal-content",
      maxWidth: 600,
      testId: testId,
      children: children
    }), footer && jsx(FullscreenLayoutFooter, {
      testId: `${testId}Footer`,
      children: footer
    })]
  });
}, {
  name: 'FullscreenLayoutContent'
});

export { FullscreenLayoutContent };
//# sourceMappingURL=FullscreenLayoutContent.js.map
